import { Directive, Input, OnChanges, TemplateRef, ViewContainerRef, inject } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[reRenderOnChange]',
  standalone: true
})
export class ReRenderOnChangeDirective implements OnChanges {
  private readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  private readonly viewContainer = inject(ViewContainerRef);

  /** Destroy and then recreates the attached element when the supplied variable changes. */
  @Input() reRenderOnChange: unknown;

  public ngOnChanges(): void {
    this.viewContainer.clear();
    this.viewContainer.createEmbeddedView(this.templateRef);
  }
}
